// eslint-disable-next-line 
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LaunchIcon from '@mui/icons-material/Launch';
import axios from 'axios';
import { ContextData } from '../../../../../../../context/Context';
import baseUrl from '../../../../../../../BaseURL';
import { toast } from 'react-toastify';
import Loader from '../../../../../../../routes/Loader';
import { Getrequest, Postrequest, Putrequest } from '../../../../../../../context/AxiosRequest';
import SoundAlert from '../../../../../../../routes/SoundAlert';

export default function Instruction(props) {


  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');
  const { accesstoken , UserTokens} = React.useContext(ContextData);
  const [ScholarshipAppliedList, setScholarshipAppliedList] = React.useState(null);
  const { user_token,loan_applied,loan_type,loan_card_token,setOpenLoader } = props;
  const [ReloadApp, setReloadApp] = React.useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  const [changeLoanForm, setChangeLoanForm] = React.useState("")

    React.useEffect(() => {

    const fetchPersonData = async () => {


      try {
      

        const loanData = await Getrequest(`/auth/get_loan_data/${UserTokens}`,accesstoken)

        if(loanData) setChangeLoanForm(loanData?.loanrequest[0]?.loan_category)


        
      } catch (error) {
        toast.error('Failed to fetch person data');
      }


    }


    if (UserTokens && accesstoken) {
      fetchPersonData();
    }


  }, [UserTokens, accesstoken]);



  const handleClickOpen = (scrollType) => () => {


    
    (async ()=>{
     
             const response = await Putrequest(`/auth/check_if_fill_all_before_apply`,{user_token,loan_category:changeLoanForm},accesstoken)

        
            if(response.status){


           
            toast.success(response.textStatus)
           
           setOpen(true);
           setScroll(scrollType);
  

          

          }else{

            toast.error(response.textStatus)
            SoundAlert("error")


          } 






    })()

     



  };


  const handleClose = () => {
    setOpen(false);
  };
 

  const handleFormSubmit = async () => {

     console.log( user_token,loan_applied,loan_type,loan_card_token)
    if (!user_token || !loan_applied || !loan_type || !loan_card_token) {
      toast.warn("All fields are required!");
      return;
    }

    setOpenLoader(true);
    setIsButtonDisabled(true);
      
       const data = {
        user_token,
        loan_applied,
        loan_type,
        loan_card_token,
       }
     
    try {
        
          const response = await Postrequest("/auth/apply_loan",data,accesstoken)
      
       if(response.status){

         toast.success(response.message);
         setReloadApp(!ReloadApp);
         setOpen(false);
         setOpenLoader(false);
         setIsButtonDisabled(true);
         SoundAlert("success")

       }else if(!response.status){

           toast.warn(response.message)
            setReloadApp(!ReloadApp);
              setOpen(false);
         setOpenLoader(false);
         setIsButtonDisabled(true);
           SoundAlert("error")
       }

    } catch (error) {
      toast.error("Error submitting application. Please try again.");
      console.error("Submission error:", error);
      setReloadApp(!ReloadApp);
      setOpenLoader(false);
      setIsButtonDisabled(false);
    }
  };

  const descriptionElementRef = React.useRef(null);

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  React.useEffect(() => {
    async function FetchData() {
      try {

      const response = await Getrequest(`/auth/get_loan_applied_list/${user_token}/${loan_card_token}`,accesstoken)
       

        setScholarshipAppliedList(response[0]);
        setIsButtonDisabled(response[0].apply_status === "applied")
        
      } catch (err) {
        if (err) console.log(err.message);
      }
    }
    FetchData();
  }, [ReloadApp]);

  return (
    <React.Fragment>
     
      <Button
        disabled={isButtonDisabled}
        onClick={handleClickOpen('paper')}
        sx={{ whiteSpace: 'nowrap', textTransform: "capitalize", fontSize: '14px', backgroundColor: 'rgb(0, 24, 69)', color: "white", margin: '9px 4px', fontWeight: "800" }}
        size="medium"
        variant="contained"
      >
        <LaunchIcon sx={{ fontSize: "1.6em", marginRight: "2px" }} /> Apply
      </Button>

      <Dialog open={open} onClose={handleClose} scroll={scroll} aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
        <DialogTitle id="scroll-dialog-title"><span className='text-cyan-900'>Read Before Apply</span></DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
            <p style={{ whiteSpace: "pre-line" }}>{props.value}</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={isButtonDisabled}
            onClick={handleFormSubmit}
            sx={{ whiteSpace: 'nowrap', textTransform: "capitalize", fontSize: '14px', backgroundColor: 'rgb(0, 24, 69)', color: "white", margin: '9px 4px', fontWeight: "800" }}
            size="medium"
            variant="contained"
          >
            <LaunchIcon sx={{ fontSize: "1.6em", marginRight: "2px" }} /> Agree and Apply
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
